import React from "react";
import Head from "next/head";

import CollectionMain from "@/components/help/collection-main";
import { useRouter } from "next/router";
import { collections } from "@/components/help/help-articles-data";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";
import { collectionSlugs } from "@/utils/help-paths";

const CollectionPage = () => {
  const router = useRouter();
  const { collection } = router.query;
  const selectedCollection = collections.find((c) => c.link === collection);

  return (
    <>
      <Head>
        <title>{seoData.HELP_CENTER.title}</title>
        <SeoMetaData data={seoData.HELP_CENTER} />
      </Head>

      <CollectionMain collection={selectedCollection} />
    </>
  );
};

// Previously had NO data function (relied on automatic static optimization +
// client useRouter()), but output:"export" hard-errors on a dynamic route
// without getStaticPaths. Enumerate every collection slug from local data so
// each collection page is prerendered (unknown slugs 404 until rebuild).
export async function getStaticPaths() {
  const paths = collectionSlugs.map((collection) => ({
    params: { collection },
  }));
  return { paths, fallback: false };
}

export async function getStaticProps({ params }: any) {
  return { props: { collection: params.collection } };
}

export default CollectionPage;
